import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dealershipBtn", "customerBtn", "formInput", "dealerMarketing"]

  selectDealership() {
    console.log(123)
    this.#activateButton(this.dealershipBtnTarget, this.customerBtnTarget)
    this.#enableInputs()
    this.dealerMarketingTargets.forEach(el => el.classList.remove('d-none'))
    document.cookie = "user_type=dealership;path=/"
  }

  selectCustomer() {
    this.#activateButton(this.customerBtnTarget, this.dealershipBtnTarget)
    this.#enableInputs()
    this.dealerMarketingTargets.forEach(el => el.classList.add('d-none'))
    document.cookie = "user_type=customer;path=/"
  }

  #activateButton(active, inactive) {
    active.classList.add('btn-primary')
    active.classList.remove('btn-outline-primary')
    inactive.classList.add('btn-outline-primary')
    inactive.classList.remove('btn-primary')
  }

  #enableInputs() {
    this.formInputTargets.forEach(input => input.disabled = false)
  }
}
